document.addEventListener('DOMContentLoaded', () => {
  // Respect Reduced Motion check
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return; // Do not initialize scroll animations
  }

  // ─── LAW 4: Scroll-Triggered Reveals via IntersectionObserver ───
  const observerConfig = {
    root: null, // viewport
    rootMargin: '0px 0px -50px 0px', // offset: 50px
    threshold: 0.05
  };

  const animationObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const target = entry.target;
        
        // Handle stagger groups if marked
        if (target.hasAttribute('data-stagger-group')) {
          staggerAnimateChildren(target);
        } else {
          target.classList.add('aos-animate');
        }
        
        observer.unobserve(target); // once: true
      }
    });
  }, observerConfig);

  // Register elements to observe
  const animatedElements = document.querySelectorAll('[data-aos="rc-fade-up"], [data-stagger-group]');
  animatedElements.forEach(el => animationObserver.observe(el));

  // ─── LAW 2: Stagger Animations ───
  function staggerAnimateChildren(parent) {
    // Find all immediate children or designated children to animate
    const selector = parent.getAttribute('data-stagger-selector') || '[data-aos="rc-fade-up"]';
    const children = Array.from(parent.querySelectorAll(selector));
    
    // Configurable stagger gap (default 80ms)
    const gap = parseInt(parent.getAttribute('data-stagger-gap'), 10) || 80;

    children.forEach((child, index) => {
      setTimeout(() => {
        child.classList.add('aos-animate');
      }, index * gap);
    });
  }
});
